export enum ErrorType {
    DIV_BY_ZERO     = '#DIV/0!',
    INVALID_NAME    = '#NAME?',
    INVALID_REF     = '#REF!',
    INVALID_VAL     = '#VALUE!',
    INVALID_NUM     = '#NUM!',
    NA              = '#N/A!',
    NULL            = '#NULL!',
    SPILL           = '#SPILL!',
    ERROR           = '#ERROR!'
}
